export const WEB3_INITIALIZING = 'WEB3_INITIALIZING'
export const WEB3_INITIALIZED = 'WEB3_INITIALIZED'
export const WEB3_FAILED = 'WEB3_FAILED'
export const WEB3_USER_DENIED = 'WEB3_USER_DENIED'

export const WEB3_DECRYPTING = 'WEB3_DECRYPTING';
export const WEB3_DECRYPTED = 'WEB3_DECRYPTED';

export const NETWORK_ID_FETCHED = 'NETWORK_ID_FETCHED'
export const NETWORK_ID_FAILED = 'NETWORK_ID_FAILED'
export const NETWORK_MISMATCH = 'NETWORK_MISMATCH'

export const NETWORK_IDS = {
    mainnet: 1,
    ropsten: 3,
    rinkeby: 4,
    goerli: 5,
    kovan: 42,
    ganache: 5777,
    sepolia: 11155111
}
